module.exports = __webpack_public_path__ + "static/media/feelingProud.a73310ea.svg";